import { INPUT_TYPE } from "../../constants/Constant";
import { INPUT_VIEW_DIRECTION } from "../SequenceNumberFormat/Other";

export const GIRO_TYPE = [
    {id:"salary", name:"Salary Giro"},
    {id:"statutory", name: "Statutory Giro"},
]

export const STATUTORY_TYPE = [
    {id:"socso", name: "SOCSO"},
    {id:"epf", name: "EPF"},
    {id:"incomeTax", name: "INCOME TAX"},
]

export const FILE_FORMAT = [
    {id:".xls", name:"XLS"},
    {id:".xlsx", name: "XLSX"},
]

export const MAKE_PAYMENT_FORM_SG = [
    {
        key:"bank",
        columnCode: "bank",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Bank",
        type:INPUT_TYPE.DROPDOWN,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false,
        uiVisible: true
    },
    {
        key:"accountNumber",
        columnCode: "accountNumber",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Account Number",
        type:INPUT_TYPE.DROPDOWN,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false,
        uiVisible: true
    },
    {
        key:"batchId",
        columnCode: "batchId",
        options:[],
        icon:"",
        validation:{
            range:{
                min:1,
            max:89999,
            maxLength: 5
            }
        },
        isValid:true,
        name:"Batch Id",
        type:INPUT_TYPE.NUMBER,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false,
        uiVisible: true,
        tooltipText: "Please enter a unique number to identify the transaction for a Pay Date.<br/> Range = 00001 to 89999",
        errorMessage: "Please enter a unique number to identify the transaction for a Pay Date. Range = 00001 to 89999"
    },
    {
        key:"payDate",
        columnCode: "payDate",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Pay Date",
        type:INPUT_TYPE.DATE,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false,
        uiVisible: true,
        tooltipText: "The selected date should not be a Sunday or Public holiday",
        errorMessage: "The selected date should not be a Sunday"
    },
    {
        key:"status",
        columnCode: "status",
        options:[{id:"",name:"All"},{id:true,name:"Generated"},{id:false,name:"Not Generated"}],
        icon:"",
        validation:null,
        isValid:true,
        name:"Status",
        type:INPUT_TYPE.DROPDOWN,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false,
        uiVisible: true
    }
]

export const MAKE_PAYMENT_FORM_MY = [
    {
        key:"bank",
        columnCode: "bank",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Bank",
        type:INPUT_TYPE.DROPDOWN,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false,
        uiVisible: true
    },
    {
        key:"accountNumber",
        columnCode: "accountNumber",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Account Number",
        type:INPUT_TYPE.DROPDOWN,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false,
        uiVisible: true
    },
    {
        key:"batchId",
        columnCode: "batchId",
        options:[],
        icon:"",
        validation:{
            range:{
                min:1,
            max:89999,
            maxLength: 5
            }
        },
        isValid:true,
        name:"Batch Id",
        type:INPUT_TYPE.NUMBER,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false,
        uiVisible: true,
        tooltipText: "Please enter a unique number to identify the transaction for a Pay Date.<br/> Range = 00001 to 89999",
        errorMessage: "Please enter a unique number to identify the transaction for a Pay Date. Range = 00001 to 89999"
    },{
        key:"recipientReference",
        columnCode: "recipientReference",
        options:[],
        icon:"",
        validation:{
            range:{
            maxLength: 20
            }
        },
        isValid:true,
        name:"Recipient Reference",
        type:INPUT_TYPE.TEXT,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:false,
        readOnly: false,
        uiVisible: false,
        tooltipText: "",
        errorMessage: ""
    },
    {
        key:"payDate",
        columnCode: "payDate",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Pay Date",
        type:INPUT_TYPE.DATE,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false,
        uiVisible: true,
        tooltipText: "The selected date should not be a Sunday or Public holiday",
        errorMessage: "The selected date should not be a Sunday"
    },
    {
        key:"status",
        columnCode: "status",
        options:[{id:"",name:"All"},{id:true,name:"Generated"},{id:false,name:"Not Generated"}],
        icon:"",
        validation:null,
        isValid:true,
        name:"Status",
        type:INPUT_TYPE.DROPDOWN,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false,
        uiVisible: true
    },
    {
        key:"giroType",
        columnCode: "giroType",
        options:GIRO_TYPE,
        icon:"",
        validation:null,
        isValid:true,
        name:"Giro Type",
        type:INPUT_TYPE.DROPDOWN,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false,
        uiVisible: true
    },
    {
        key:"statutoryType",
        columnCode: "statutoryType",
        options:STATUTORY_TYPE,
        icon:"",
        validation:null,
        isValid:true,
        name:"Statutory Type",
        type:INPUT_TYPE.DROPDOWN,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:false,
        readOnly: false,
        uiVisible: false
    },
    {
        key:"fileFormat",
        columnCode: "fileFormat",
        options:FILE_FORMAT,
        icon:"",
        validation:null,
        isValid:true,
        name:"File Format",
        type:INPUT_TYPE.DROPDOWN,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:false,
        readOnly: false,
        uiVisible: false
    }
]

export const MANDATORY_FIELDS = {
    ["CIMBBANK_salary_"] : ["Tax Details"],
    ["CIMBBANK_statutory_epf"]: ["Tax Details", "EPF Account"],
    ["CIMBBANK_statutory_socso"] : ["Tax Details", "Company Number"],
    ["CIMBBANK_statutory_incomeTax"] : ["Tax Details", "Company Number"],
    ["MayBank(2E)_salary_"] : ["Tax Details"],
    ["MayBank(2E)_statutory_epf"]: ["Tax Details", "EPF Account", "Company Number"],
    ["MayBank(2E)_statutory_socso"] : ["Tax Details", "Company Number"],
    ["MayBank(2E)_statutory_incomeTax"] : ["Tax Details", "Company Number"],
    ["MayBank(2E)_advice_"] : ["Tax Details"],
    ["HongLeongBank_salary_"]:[],
    ["HongLeongBank_statutory_epf"]:["Tax Details", "EPF Account", "Company Number"],
    ["HongLeongBank_statutory_incomeTax"]:["Tax Details","Company Number"],
    ["HongLeongBank_statutory_socso"]:["Tax Details"]
}